import PromoBannerDefault from "@/components/PromoBanner/variants/Default";
import PromoBannerBento from "@/components/PromoBanner/variants/Bento";
import PromoBannerSlim from "@/components/PromoBanner/variants/Slim";
import type { PromoBannerProps } from "@/components/PromoBanner/types";

export default function PromoBanner({
  variant = "default",
  ...props
}: PromoBannerProps) {
  switch (variant) {
    case "bento":
      return <PromoBannerBento {...props} />;
    case "slim":
      return <PromoBannerSlim {...props} />;
    case "countdown": // @todo implement countdown variant
    case "default":
    default:
      return <PromoBannerDefault {...props} />;
  }
}
